import { Point } from '../../../../../common/maths/geometry/pointTypes';

export type ImageModalZoomTransformElements = {
    panElement: HTMLElement | null;
    frameElement: HTMLElement | null;
};

/**
 * Applies the V2 split-transform zoom model directly to the pan and frame elements.
 */
export const applyImageModalZoomTransform = (
    { panElement, frameElement }: ImageModalZoomTransformElements,
    { scale, translation }: { scale: number; translation: Point },
): void => {
    if (panElement) {
        panElement.style.transform = `translate3d(${translation.x}px, ${translation.y}px, 0)`;
    }

    if (frameElement) {
        frameElement.style.transform = `scale(${scale})`;
        frameElement.style.transformOrigin = 'center center';
    }
};
